import {
  setBackdropState,
  utilHideLiveChat,
  utilShowLiveChat,
  trapFocus,
} from "../helpers/util";
import { Tracking } from "../helpers/enums";
import { pageTracking } from "../tracking/tracking";
import { breakpoints } from "../helpers/breakpoints";

export const accountOverlay = () => {
  const root = document.querySelector("[js-account-overlay]") as HTMLElement;

  if (!root) {
    return;
  }

  // named attrib of each view (login, register etc.) in the account overlay
  const VIEWS = {
    LOGIN: "js-account-overlay-view-login",
    REGISTER: "js-account-overlay-view-register",
    RESET: "js-account-overlay-view-pass-reset",
    MIGRATION: "js-account-overlay-view-migration",
    RESET_SUCCESS: "js-account-overlay-view-pass-reset-success",
  };

  const accountOverlayCloseCtas = root.querySelectorAll(
    "[js-account-overlay-close]"
  );

  const accountOverlayDialog = root.querySelector(
    "[js-account-overlay-dialog]"
  ) as HTMLElement;

  const viewSwitchCtas = root.querySelectorAll(
    "[js-account-overlay-switch-view]"
  );

  const overlayHeader = root.querySelector(
    "[js-account-overlay-header]"
  ) as HTMLElement;

  const featureList = root.querySelector(
    "[js-account-overlay-feature-list]"
  ) as HTMLElement;

  const setActiveView = (viewName: string) => {
    const viewNames = Object.values(VIEWS);

    if (!viewNames.includes(viewName)) {
      return;
    }

    // hide inactive views
    const inactiveViews = viewNames.filter((v) => v != viewName);
    inactiveViews.forEach((v) =>
      root.querySelector(`[${v}]`)?.classList.add("display--n")
    );

    // show active view
    const nextView = root.querySelector(`[${viewName}]`);
    nextView?.classList.remove("display--n");

    // set overlay title content
    const nextTitle =
      nextView?.getAttribute("js-account-overlay-view-header") ?? "";
    overlayHeader.textContent = nextTitle;

    const showSmallView = [
      VIEWS.RESET,
      VIEWS.MIGRATION,
      VIEWS.RESET_SUCCESS,
    ].includes(viewName);

    // reset password view doesn't show features list, and is narrower
    if (showSmallView) {
      if (featureList) {
        featureList.classList.add("display--n");
      }

      accountOverlayDialog.classList.remove("max-w--login-register");
      accountOverlayDialog.classList.add("max-w--forgot-pass");

      if (viewName === VIEWS.RESET) {
        setBackdropState(root, true);
      }
    } else {
      if (featureList) {
        featureList.classList.remove("display--n");
      }

      accountOverlayDialog.classList.add("max-w--login-register");
      accountOverlayDialog.classList.remove("max-w--forgot-pass");
    }

    //Hide live chat if mobile
    if (window.innerWidth < breakpoints.screen1024) {
      utilHideLiveChat();
    }

    root.focus();
    trapFocus(root);
  };

  if (accountOverlayCloseCtas.length) {
    accountOverlayCloseCtas.forEach((cta) => {
      cta.addEventListener("click", () => {
        setBackdropState(root, false);
        //Re show live chat
        utilShowLiveChat();
      });
    });
  }

  if (viewSwitchCtas) {
    viewSwitchCtas.forEach((cta) => {
      cta.addEventListener("click", (e) => {
        const nextView = e.target?.getAttribute(
          "js-account-overlay-switch-view"
        );

        if (nextView === VIEWS.REGISTER) {
          pageTracking(Tracking.MEMBER_REGISTER_OVERLAY);
        } else if (nextView === VIEWS.LOGIN) {
          pageTracking(Tracking.MEMBER_LOGIN_OVERLAY);
        } else if (nextView === VIEWS.RESET) {
          pageTracking(Tracking.MEMBER_RESET_OVERLAY);
        }

        setActiveView(nextView);
      });
    });
  }

  document.addEventListener("js-account-overlay", (e) => {
    const { status } = e.detail;

    if (status == "show") {
      // default to login view on open
      setActiveView(VIEWS.LOGIN);
      setBackdropState(root, true);

      pageTracking(Tracking.MEMBER_LOGIN_OVERLAY);
    }
  });

  // set initial view, either based on attribute or defaulting to login
  const startingView =
    root.getAttribute("js-account-overlay-active-view") ?? VIEWS.LOGIN;

  setActiveView(startingView);
};
